import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';

@Component
export default class HybridFormFieldTextinput extends Vue {
    public title: string = 'HybridFormFieldTextinput';

    public value = '';

    public focus = false;

    @Prop({
        default: () => {
            return (val: any) => {
                return val;
            };
        }
    })
    public formatFunc: any;

    @Prop({ default: 'Place Holder' })
    public placeholder: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    @Watch('value', { immediate: true, deep: true })
    public onValueInput(val: any, oldVal: any) {
        this.value = this.formatFunc(val);
        this.$emit('input', this.value);
    }

    public clearInput() {
        this.value = '';
    }

    public keyboardWatch() { }

    public inputEmit(v: any) {
        this.value = v;
        this.$emit('input', this.value);
    }
}
